import React from 'react';
import { CTAButton } from '../CTAButton';
export function AboutSection() {
  return <section className="w-full bg-white" data-id="element-59" data-mp="cgpzdtqzyaxc">
      <div className="mx-auto w-full max-w-content px-5 py-14 sm:px-8 sm:py-20" data-id="element-60" data-mp="chhyhejsyqsd">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-teal lg:text-left" data-id="element-61" data-mp="hezxac43vpmn">
          Su Dr. Karito
        </p>

        <div className="mt-6 grid items-start gap-8 lg:grid-cols-[minmax(0,340px)_minmax(0,1fr)] lg:gap-12" data-id="element-62" data-mp="lfbhxowgxpy4">
          <figure className="mx-auto w-full max-w-[320px]" data-id="element-63" data-mp="vfu6uy2w3wmw">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/7cbd0634-c18d-426f-a02b-9a5ea501eeb3.jpg" alt="Dr. Karito, creatrice del Progetto Clinico della Menopausa" className="w-full rounded-3xl object-cover ring-1 ring-ink/10" width={800} height={1000} loading="lazy" data-id="element-64" data-mp="ve9e9e04ynro" />
            <figcaption className="mt-3 text-center text-[13px] font-semibold text-ink/55" data-id="element-65" data-mp="1e73l1knlv9kt">
              Dr. Karito, creatrice del Progetto Clinico della Menopausa
            </figcaption>
          </figure>

          <div data-id="element-66" data-mp="19j913qlfruov">
            <h2 className="text-balance font-display text-[27px] font-black leading-[1.12] tracking-[-0.02em] text-plum-deep sm:text-[34px]" data-id="element-67" data-mp="19mwtunj24d2j">
              Il Progetto Clinico della Menopausa™ è stato creato per risolvere una delle più
              grandi sfide che i medici affrontano:
            </h2>
            <p className="mt-4 text-[17px] font-extrabold text-teal sm:text-xl" data-id="element-68" data-mp="1xchh3im8twhm">
              Trasformare le evidenze in decisioni cliniche sicure.
            </p>

            <div className="mt-6 space-y-4 text-[15.5px] leading-relaxed text-ink/70 sm:text-base" data-id="element-69" data-mp="1nja9rs7y06ew">
              <p data-id="element-70" data-mp="1ikp7ln94rcnt">
                Le linee guida di oggi sono eccellenti. Ma spesso sono lunghe, frammentate e
                difficili da applicare durante una giornata clinica intensa.
              </p>
              <p data-id="element-71" data-mp="2b8l6mym69gnr">
                Dr. Karito ha sviluppato un framework clinico strutturato che trasforma le più
                recenti raccomandazioni internazionali in percorsi decisionali pratici e passo dopo
                passo che i medici possono utilizzare immediatamente.
              </p>
              <p className="font-semibold text-plum-deep" data-id="element-72" data-mp="3vrovrpysxs6j">
                L’obiettivo non è semplicemente imparare di più. È prendere decisioni cliniche
                migliori con maggiore sicurezza.
              </p>
            </div>

            <div className="mt-8 max-w-xl" data-id="element-73" data-mp="3qt3wptvadejo">
              <CTAButton label="Voglio il sistema clinico della Dr. Karito" sub="Solo 19 € oggi • Accesso a vita" variant="teal" data-id="element-74" data-mp="3qtwvo8o06zr9" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}